import { getBrowserLocale } from 'lib/utils/locale';

export const browserLanguage = getBrowserLocale();

export const javaEnabled = window.navigator ? navigator.javaEnabled() : false;

export const screenWidth = window.screen ? window.screen.width : '';

export const screenHeight = window.screen ? window.screen.height : '';

export const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

export const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

export const screenColorDepth = window.screen ? window.screen.colorDepth : '';
